import {ComponentProps} from "react";

import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";

export const HomepageSearchDropdownList: NonNullable<ComponentProps<typeof SearchAutocomplete>["renderDropdownList"]> = (innerProps) => (
    <SearchAutocompleteDropdown
        dropdownIsOpen={innerProps.dropdownIsOpen}
        search={innerProps.search}
        selectedTab={innerProps.selectedTab}
        onLinkClick={innerProps.onLinkClick}
        requestStateObj={innerProps.requestStateObj}
        activeItem={innerProps.activeItem}
        offers={innerProps.offers}
        places={innerProps.places}
        regions={innerProps.regions}
        removeRegionTag={innerProps.removeRegionTag}
        vendors={innerProps.vendors}
        getFieldProps={innerProps.getFieldProps}
    />
);
import {ComponentProps} from "react";

import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";

export const HomepageSearchDropdownList: NonNullable<ComponentProps<typeof SearchAutocomplete>["renderDropdownList"]> = (innerProps) => (
    <SearchAutocompleteDropdown
        dropdownIsOpen={innerProps.dropdownIsOpen}
        search={innerProps.search}
        selectedTab={innerProps.selectedTab}
        onLinkClick={innerProps.onLinkClick}
        requestStateObj={innerProps.requestStateObj}
        activeItem={innerProps.activeItem}
        offers={innerProps.offers}
        places={innerProps.places}
        regions={innerProps.regions}
        removeRegionTag={innerProps.removeRegionTag}
        vendors={innerProps.vendors}
        getFieldProps={innerProps.getFieldProps}
    />
);
